import React from 'react'
interface IProps {
  value: any
  as?: React.ElementType
}
export const HTMLText = ({ value, as: Component = 'div' }: IProps) => {
  return <Component dangerouslySetInnerHTML={value && { __html: value }}></Component>
}
